module.exports = __webpack_public_path__ + "media/zk.1ad3749c.mp4";